import RevealText from "../shared/RevealText";
import WhatsAppButton from "../shared/WhatsAppButton";
import Eyebrow from "../shared/Eyebrow";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export default function FinalCTA({
  heading = "Ready to transform\nyour space?",
  body = "Send us your property details and photos through WhatsApp. Our team will recommend the most suitable cleaning service and provide a prompt quotation.",
  service,
}) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["-10%", "10%"]);

  return (
    <section
      ref={ref}
      className="relative bg-ink overflow-hidden"
      data-testid="final-cta"
    >
      <motion.div style={{ y }} className="absolute inset-0 -z-10">
        <img
          src="/generated/final_cta.png"
          alt=""
          className="w-full h-full object-cover opacity-40"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/85 to-ink/50" />
      </motion.div>

      <div className="container-emilio py-28 md:py-40 relative">
        <Eyebrow>Book On WhatsApp</Eyebrow>
        <RevealText
          as="h2"
          text={heading}
          className="mt-6 font-display font-extrabold text-white text-hero max-w-4xl"
        />
        <p className="mt-6 text-mutedtext text-base md:text-lg max-w-2xl leading-relaxed">
          {body}
        </p>
        <div className="mt-10">
          <WhatsAppButton
            label="Get a Free Quote via WhatsApp"
            size="lg"
            service={service}
            testId="final-cta-whatsapp"
          />
        </div>
      </div>
    </section>
  );
}
